import { matchPath } from 'react-router';

export const capitalize = (s) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const anyTrue = (obj = {}) =>
  Object.values(obj).some((value) => !!value);

export const allTrue = (obj = {}) =>
  Object.values(obj).every((value) => !!value);

export const stringToBool = (str = '') => {
  if (str.toLowerCase() === 'true') {
    return true;
  }

  if (str.toLowerCase() === 'false') {
    return false;
  }

  return null;
};

export const range = (start, end, step = 1) =>
  Array.from(new Array(end), (x, i) => i * step + start);

export const checkMatchPath = (
  pathToCheck: string | undefined,
  targetPath: string | undefined
) => {
  if (!pathToCheck || !targetPath) return false;

  // v6 matchPath only handles pathnames — strip query strings before matching
  const [targetPathname, targetSearch] = targetPath.split('?');
  const [checkPathname, checkSearch] = pathToCheck.split('?');

  const pathnameMatch = matchPath(
    { path: targetPathname || '/', end: true },
    checkPathname || '/'
  );
  if (!pathnameMatch) return false;

  // If the checked URL has query params, the target must also declare them and
  // the URL must satisfy all of them. If the URL has params but the target
  // declares none, it is more specific (e.g. '/?bp_e=token' vs '/') — no match.
  if (checkSearch) {
    if (!targetSearch) return false;
    const targetParams = new URLSearchParams(targetSearch);
    const checkParams = new URLSearchParams(checkSearch);
    for (const [key, value] of targetParams.entries()) {
      if (!checkParams.has(key)) return false;
      // Values starting with ':' are param placeholders — any value matches
      if (!value.startsWith(':') && checkParams.get(key) !== value)
        return false;
    }
  } else if (targetSearch) {
    // Target requires query params but the URL has none — no match.
    return false;
  }

  return true;
};

/* istanbul ignore next -- @preserve */
export const loadScript = async (url: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const tag = document.createElement('script');

    tag.type = 'text/javascript';
    tag.onload = () => resolve();
    tag.onerror = () => reject(new Error(`Failed to load script: ${url}`));

    tag.src = url;
    document.body.appendChild(tag);
  });
};

export const maskPartialData = (
  value?: string,
  visibleCount = 4,
  maskChar = '*',
  maskLength?: number
): string => {
  if (!value || value.length <= visibleCount) {
    return value ?? '';
  }

  if (maskLength !== undefined && maskLength > 0) {
    return maskChar.repeat(maskLength) + value.slice(-visibleCount);
  }

  return value.replace(new RegExp(`.(?=.{${visibleCount}})`, 'g'), maskChar);
};

export const countErrorCodeOccurrences = (errors, code) =>
  errors.reduce((count, error) => count + (error.code === code ? 1 : 0), 0);
